<template>
<div>
    <section class="hero is-fullheight is-light">
        <div class="container">
            <figure class="image">
                <img src="https://tan.netlify.app/pics/husky_certificate_contribution_2007_hires.webp"/>
                <!-- <figurecaption>award</figurecaption> -->
            </figure>
        </div>
    </section>

    <div class="section">
        <!-- <div class="box">
                <div class="field has-addons">
                    <div class="control is-expanded">
                        <input class="input has-text-centered" type="search" placeholder="» » » » » » find me « « « « « «">
                    </div>
                    <div class="control">
                        <a class="button is-info">Search</a>
                    </div>
                </div>
      </div>-->
        <!-- Developers -->
        <div class="row columns">
            <div class="column is-one-third" v-for="pic in img_certificates" :key="pic">
                <div class="card large">
                    <div class="card-image">
                        <a class="image" :href="append_host(pic)">
                            <figure class="image">
                                <!-- <img :src='append_host_for_thumbs(pic)' :alt='pic'> -->
                                <img :src="append_host(pic)" :alt="pic">
                            </figure>
                        </a>
                    </div>
                    <div class="card-content">
                        <!-- <div class="media">
                                <div class="media-left">
                                    <figure class="image is-96x96">
                                        <img src="https://i.imgsafe.org/a4/a4bb9acc5e.jpeg" alt="Image">
                                    </figure>
                                </div>
                                <div class="media-content">
                                    <p class="title is-4 no-padding">Okinami</p>
                                    <p><span class="title is-6"><a href="http://twitter.com/#">@twitterid</a></span></p>
                                    <p class="subtitle is-6">Lead Developer</p>
                                </div>
              </div>-->
                        <div class="content">
                            <!-- The Beast stumbled in the dark for it could no longer see the path. It started to fracture and weaken, trying to reshape itself into the form of metal. Even the witches would no longer lay eyes upon it, for it had become hideous and twisted. -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Developers -->
        <!-- Staff -->
        <div class="row columns is-multiline">
            <div class="column is-one-third" v-for="pic in img_workpieces " :key="pic">
                <div class="card large round">
                    <div class="card-image">
                        <a class="image" :href="append_host(pic)">
                            <figure class="image">
                                <!-- <img :src='append_host_for_thumbs(pic)' :alt='pic'> -->
                                <img :src="append_host(pic)" :alt="pic">
                            </figure>
                        </a>
                    </div>
                    <div class="card-content">
                        <!-- <div class="media">
                                <div class="media-left">
                                    <figure class="image is-96x96">
                                        <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/331810/profile-sample5.webp" alt="Image">
                                    </figure>
                                </div>
                                <div class="media-content">
                                    <p class="title is-4 no-padding">Atsui</p>
                                    <p><span class="title is-6"><a href="http://twitter.com/#">@twitterid</a></span></p>
                                    <p class="subtitle is-6">Moderator</p>
                                </div>
              </div>-->
                        <!-- <div class="content">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam! Labore reprehenderit beatae magnam animi!
              </div>-->
                    </div>
                </div>
            </div>
        </div>
        <!-- End Staff -->
    </div>
</div>
</template>

<script>
// import husky_contribution from "../assets/img/husky-contribution.webp";
export default {
    data() {
        return {
            // husky_contribution: husky_contribution,
            image_host: 'https://tan.netlify.app/pics/',

            img_certificates: [
                // "husky_certificate_contribution_2007.webp",
                "home_iot_parking.webp",
                "home_hotelbooking.webp",
                "husky_mbti_profile_1.webp",
                "husky_mbti_profile_2.webp",
                "husky-certificate-7-habbits-2008.webp",
                "husky_employee_engagement_survey_page_7.webp",
                "husky_employee_engagement_survey_page_8.webp",
                "husky_certificate_leadership_2006.webp",
                "unicef-2017.webp",
                "unicef_2009.webp"
            ],

            img_workpieces: [
                "dediprog_sf100.webp",
                "dediprog_sf100_in_use.webp",
                "dediprog_load_file.webp",
                "dediprog_settings.webp",
                "dediprog_winusbpp.webp",
                "husky_hotrunner-product-comp.webp",
                "husky_machine_hypersync.webp",
                "husky-hypersynch-625.webp",
                "husky_altanium.webp",
                "husky_ipc.webp",
                "husky_ssnx_small.webp",
                "husky_ssnx.webp",
                "husky_app_heatlogger_main.webp",
                "husky_app_heatlogger_options.webp",
                "husky_app_hklabel.webp",
                "husky_app_zebra_linux_ubuntu.webp",
                "husky_app_zebra.webp",
                "husky_bq_arch_old.webp",
                "husky_bq_arch_new.webp",
                "husky_bq_arch.webp",
                "husky_bq_search.webp",
                "husky_bq_acupuncture-2.webp",
                "husky_bq_acupuncture-1.webp",
                "husky_bq_mobile.webp",
                "husky_bq_transformers_idle.webp",
                "husky_hostlinkpp_multi_host_concurrent_communication.webp",
                "husky_hostlinkpp_simulator_linux_ubuntu.webp",
                "husky_twincat_tsm_viewer_io_dependency_graph.webp",
                "husky_twincat_tsm_viewer_realtime_config.webp",
                "husky_wb_overview.webp",
                "husky_wb_projects.webp",
                "husky_hmi.webp",
                "husky_hmi-small.webp",
                "husky_cycle-optimization.webp",
                "husky_matrix1.webp",
                "husky_matrix2_without_memory_footprint.webp",
                "st-oscilloscope.webp",
                "st_anatidae.webp",
                "st_egret_1.webp",
                "st_egret_2.webp",
                "seci_labutils_1.webp",
                "seci_labutils_2.webp",
                "seci_labutils_3.webp",
                "seci_labutils_4.webp",
                "literalConversion_gui.webp",
                "literalConversion_cli.webp",
                "hit_acb.webp",
                "hit_cb.webp",
                "hit_cb_curve.webp",
                "hit_cb_settings.webp",
                "hit_contactor_alt.webp",
                "hit_front.webp",
                "hit_thermorelay_alt.webp",
                "hobby_2d_water_effect.webp",
                "hobby_duplicate_finder.webp"
            ]
        };
    },
    methods: {
        append_host(image) {
            return this.image_host + image;
        },
        append_host_for_thumbs(image) {
            return this.image_host + image.replace(".webp", ".webp");
        }
    }
};
</script>

<style scoped>
img {
    /* filter: contrast(2); */
    /* filter:blur(1px); */
}
</style>



// WEBPACK FOOTER //
// src/components/landing_gallery.vue